import React, {Component} from 'react';
import Tile from '../Tile'

class RadarCallToAction extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate
    this.warnEspImagePath = props.warnEspRadarImagePath + '?' + Date.now()
  }

  render() {
    return (<div className='gnm-radar-call-to-action'>
      <div className='row'>
        <div className='col-md-6'>
          <CallToAction destination={this.props.affiliate === 'kotv'
              ? "/warn-interactive-live-radar"
              : "/esp-radar"} imagePath={this.warnEspImagePath} title={this.props.affiliate === 'kotv'
              ? "WARN"
              : "ESP"}/>
        </div>
        <div className='col-md-6'>
          <CallToAction destination="u-control-weather-center" imagePath={this.props.uControlImagePath} title="U-Control"/>
        </div>
      </div>
    </div>)
  }
}

const CallToAction = (props) => {
  let story = {
    headline: props.title,
    abstractimage: {
      filename: props.imagePath
    },
    link: props.destination
  }
  return (<Tile story={story} gradient={true}></Tile>)
}

export default RadarCallToAction;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/RadarCallToAction/index.js